import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from "../../../store";
import Utils from "../../../utils/Utils";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import { ENABLE_HTTPS } from "../../RequestManagerConstants";
import Device from "../../../devices/device";

class TVEverywhereSaveTask extends AbstractRequestTask {
  constructor(email = "") {
    super();
    this.email = email;
  }

  getParams() {
    const { email } = this;
    const { user = {} } = store.getState();
    const user_hash = DeviceStorage.getItem('user_hash');
    const { serial_id } = Device.getDevice().getConfig();

    return Object.assign({}, { email, user_hash, serial_id });
  }

  getHeaders() {
    return {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  }

  getGETParams() {
    const params = super.getParams();
    const {api_version, ...restParams} = params;
    const region = DeviceStorage.getItem('region');

    return Object.assign(restParams, { region });
  }

  getUrl() {
    const http = "https://";
    // const url = "userdata-pre.clarovideo.net"
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/user/v1/profile/data/save?` + Utils.buildQueryParams(this.getGETParams());
  }

  isValid(data) {
    return true;
  }

  getMethod() {
    return 'POST';
  }

  getShowErrorModal(){
		return false;
	}

  showModalRetry() {
    return false
  }

  getEncType() {
    return 'application/x-www-form-urlencoded';
  }

  getIsByHttps(){
    return ENABLE_HTTPS;
  }
}

export default TVEverywhereSaveTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/TVEverywhereSaveTask.js